import { partnerSites } from '../consts/partnerSites.const';
import { THEME_IDS } from '../consts/themes.const';

export const resolvePartnerSite = (origin?: string) => {
  return partnerSites.find(site => site.origin === origin) ?? null;
};

export const resolveThemeId = (origin?: string) => {
  return resolvePartnerSite(origin)?.themeId ?? THEME_IDS.LIGHT;
};
